export default __webpack_public_path__ + "static/media/gravel_cover.fe324bf9.jpg";